<template>
    <div class="main-content-container  container-fluid ">
        <div class="page-header row no-gutters py-4  mb-4">
            <div class="col-12 col-sm-4 text-center text-sm-left mb-0">
                <span class="text-uppercase page-subtitle">{{$t("HISTORICS.HISTORICS")}}</span>
            </div>
        </div>

        <w-card size="100">
            <div class="row mb-4">
                <div class="col-12 ">
                    <div class="row align-items-center justify-content-center">
                        <div class="col-12 col-lg-6 text-lg-left text-center">
                            <el-select class="mr-1 mb-1 mb-xl-0" v-model="selectedSiteId" v-loading="loadingSites">
                                <el-option
                                        v-for="item in sites"
                                        :key="item.id"
                                        :label="item.nombre"
                                        :value="item.id"
                                >
                                </el-option>
                            </el-select>
                            <el-select class="mr-1 mb-1 mb-xl-0" v-model="selectedSiloId"
                                       v-loading="loadingSilos || loadingSites">
                                <el-option
                                        v-for="item in silos"
                                        :key="item.id"
                                        :label="item.nombre"
                                        :value="item.id"
                                >
                                </el-option>
                            </el-select>
                        </div>
                        <div class="col-12 col-lg-6 text-lg-right text-center">
                            <el-date-picker
                                    class="mr-1 mb-1 mb-sm-0"
                                    v-model="date"
                                    type="daterange"
                                    :clearable="false"
                                    :placeholder="$t('HISTORICS.PICK_A_DATE')"                                   
                                    :start-placeholder="$t('HISTORICS.DATE_FROM')"
                                    :end-placeholder="$t('HISTORICS.DATE_TO')"
                            >
                            </el-date-picker>
                        </div>
                    </div>
                    <hr>
                </div>
            </div>
            <div class="row">
                <div id="chart"></div>
            </div>
            <h5 v-if="!userHasSites" class="text-center text-invalid">{{$t('HISTORICS.NO_SITES') }}</h5>
            <historic-container class="mb-4" v-if="silo !== undefined" :from="date[0]"
                            :to="date[1]" :siteId="selectedSiteId" :silo="silo"/>

        </w-card>
    </div>
</template>

<script>
    import api from "../utils/api/api.js"
    import wCard from "../components/common/wCard";
    import historicChart from "../components/common/charts/historicChart";
    import HistoricContainer from "../components/common/HistoricContainer"

    export default {
        name: "stats",
        components: {
            "w-card": wCard,
            "historic-chart": historicChart,
            "historic-container": HistoricContainer
        },
        data: function () {
            return {
                date: [new Date(new Date().getTime() - 7 * (1000 * 60 * 60 * 24)), new Date()],
                sites: [],
                selectedSiteId: undefined,
                selectedSiloId: undefined,
                silos: [],
                sections: [],
                pendingSectionResult: undefined,
                loadingSilos: undefined,
                userHasSites: true
            }
        },
        computed: {
            loadingSites: function () {
                return this.sites.length === 0 && this.userHasSites;
            },
            silo: function () {
                return this.silos.find(value => value.id === this.selectedSiloId);
            }
        },
        watch: {
            selectedSiteId: function () {
                if (this.selectedSiteId === undefined) {
                    this.silos = [];
                }
                this.loadingSilos = true;
                api.getSilos(this.selectedSiteId).then(value => {
                    this.silos = value.silos;
                    this.silos.sort((a, b) => {
                        return b.cant_sens - a.cant_sens
                    });
                    if (this.silos.length > 0) {
                        this.selectedSiloId = this.silos[0].id
                    }
                    this.loadingSilos = false;
                }).catch(reason => {
                    this.loadingSilos = false
                });
            },
        },

        mounted() {
            api.getSites().then(value => {
                this.sites = value.sites;
                if (this.sites.length > 0 && this.sites[0].id !== undefined) {
                    this.selectedSiteId = this.sites[0].id;
                }
            }).catch(reason => {
                console.error("no hay sitios", reason);
                if (reason.code === 17) {
                    this.userHasSites = false;
                }
            })
        }

    }
</script>

<style>

</style>